import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import clsx from 'clsx';
import Button from '../../atomicComponents/Button/Button';
import defaultStyles from './DatePicker.module.css';
import jlrStyles from './DatePickerJlr.module.css';
import { getDatesForRange, setStylesAccordingToPlant } from '../../utils/utils';
import { DATE_FORMAT } from '../../constants';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';

const DatePicker = ({
  startDate,
  endDate,
  activeDate,
  handleSelectedDate,
  handlePreviousDate,
  buttonTitle,
  datePickerMonthPreFix,
}) => {
  if (startDate && endDate && endDate.isBefore(startDate, 'day'))
    throw new Error('endDate cannot be before startDate');

  const [plant] = usePlantAndLinesStore().plantState;
  const [styles, setStyles] = useState(defaultStyles);

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]);

  return (
    <div className={styles.datePickerContainer}>
      {buttonTitle && (
        <Button
          className={
            activeDate && activeDate.isBefore(moment().subtract(1, 'days'))
              ? clsx(styles.previousButton, styles.selectedPrevious)
              : styles.previousButton
          }
          onClick={() => handlePreviousDate()}
          data-testid="contextual-button"
        >
          {buttonTitle}
        </Button>
      )}
      <span className={styles.monthOfSelectedDate} id="month">
        {startDate && endDate
          ? `${datePickerMonthPreFix || ''} ${activeDate?.format('MMMM')}`
          : ' - - '}
      </span>
      {startDate && endDate ? (
        getDatesForRange(startDate, endDate).map(date => (
          <Button
            key={date.format('DD-MMM')}
            className={
              date.isSame(activeDate, 'day')
                ? clsx(styles.circularButton, styles.selectedDate)
                : styles.circularButton
            }
            onClick={() => handleSelectedDate(date)}
            aria-label={`select-date-${date.format(DATE_FORMAT.ISO)}`}
          >
            {date.format('DD')}
          </Button>
        ))
      ) : (
        <span className={styles.noDateRangeGiven}> No ASN Available</span>
      )}
    </div>
  );
};

DatePicker.propTypes = {
  startDate: PropTypes.objectOf(moment),
  endDate: PropTypes.objectOf(moment),
  activeDate: PropTypes.objectOf(moment),
  handleSelectedDate: PropTypes.func,
  handlePreviousDate: PropTypes.func,
  buttonTitle: PropTypes.string,
};

export default DatePicker;
